import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { TertiaryButton, Typography } from '@dev/ee-components';
import { ShowDialog } from '@/store/dialog/actions';
import { CheckoutsTermsLoadStart } from "@/store/checkoutTerms/actions";

import { useTermsAndConditionsModalParams } from './hooks/useTermsAndConditionsModalParams';
import { FormMultiTermsWrapper } from './styles';

export const FormMultiTerms = (): JSX.Element => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { getTermsAndConditionsModalParams } = useTermsAndConditionsModalParams();
    
    useEffect(() => {
        dispatch(CheckoutsTermsLoadStart());
    }, []);

    const onPreviewClick = (): void => {
        dispatch(ShowDialog(getTermsAndConditionsModalParams()));
    };

    return <FormMultiTermsWrapper>
        <Typography variant="body1">
            {t('termsandconditions_checkoutsinfo')}</Typography>
        <div><TertiaryButton onClick={onPreviewClick} text={t('preview')} /></div>
    </FormMultiTermsWrapper>;
};
